export enum OsmVersionStatusType {
  IMPORTED = 'imported',
  MATCHED = 'matched',
  APPROVED = 'approved',
  OLD = 'old',
  DELETED = 'deleted'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/osmversionstatustype.ts